import React from 'react';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';

const SecurityLogo = React.memo(() => {
  return (
    <img
      src={getCompressedAssetUrl('/web_v2/uh-home-v2/misc/security-logo.png')}
      alt="Security certification logo"
      width={142}
      height={176}
      style={{ display: 'block' }}
    />
  );
});

SecurityLogo.displayName = 'SecurityLogo';

export default SecurityLogo;
